<template>
    <div class="hidden sm:block">
        <div class="h-screen w-16 flex flex-col justify-between items-center sticky top-0 bg-white shadow-2xl">
            <router-link to="/workspace" class="select-none">
                <img class="pointer w-10 h-10 mt-8" src="../assets/nav_bar_icons/logo.svg" alt="logo">
            </router-link>
            <div class="nav-bar_buttons">
                <BaseButton v-on:click="this.$router.push(button.route)" v-for="button in this.buttons" v-bind:key="button" :src="button.icon_path" v-bind:title="button.name"/>
            </div>
        </div>
    </div>

</template>

<script> 
    import BaseButton from './UI/BaseButton.vue';
    export default {
        name: "NavigationBar",
        components: {
            BaseButton,
        },
        data() {
            return {
                buttons: [
                    {
                        name: 'Workspace',
                        route: '/workspace',
                        icon_path: require('../assets/nav_bar_icons/home.svg')
                    },
                    {
                        name: "Me",
                        route: "/me",
                        icon_path: require('../assets/nav_bar_icons/profile.svg')
                    }
                ]
            }
        },
        methods: {
        },
    }
</script>

<style scoped>
    .nav-bar {
        display: flex;
        flex-direction: column;
        width: 80px;
        height: 100vh;
        padding: 16px 8px;
        border-right: 1px solid transparent;
        justify-content: space-between;
        align-items: center;
        position: fixed;
    }

    .nav-bar_buttons {
        display: flex;
        flex-direction: column;
    }
    .logo {
        cursor: pointer;
        margin-top: 10px;
    }
</style>
